module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4euLS"))).then(() => parcelRequire('d0iPb'));